import { apiRoutes } from "../../config"
import { api } from "../../utils/lib/api"



export const getDataApiDebug = async (params)=>{
    try {
        //Obtenemos el id de la cuenta de Vtex
        const url = `${apiRoutes.debug.getApiDebugById}/`
        return (await api.get(url, 
            {
                params:{
                    page: params.page,
                    limit: params.limit,
                    productId: params.productId,
                    sku: params.sku,
                    enterpriseId: params.enterpriseId,
            }}
    ))
    } catch (error) {
        console.log(error)
        throw error

    }
}
 

export const getDataCronDebug = async (code, params)=>{
    try {
        const url = `${apiRoutes.debug.getCronDebugByCode}/${code}`
        return (await api.get(url, 
            {
                params:{
                    page: params.page,
                    limit: params.limit,
                }}
    ))
    } catch (error) {
        console.log(error)
        throw error

    }
}

export const getDataNotificationProcess = async (plugin, params)=>{
    try {
        const url = `${apiRoutes.debug.getNotificationProcess}`
        const pluginValue = plugin?.trim();
        if (!pluginValue) {
            throw new Error("Plugin requerido para consultar Notification Process");
        }

        const requestParams = {
            pageNumber: params.page,
            pageItemCount: params.limit,
            plugin: pluginValue,
        };
        
        if (params.orderId) {
            requestParams.orderId = params.orderId;
        }
        
        if (params.route) {
            requestParams.route = params.route;
        }

        if (params.productId) {
            requestParams.productId = params.productId;
        }
        
        const response = await api.get(url, {
            params: requestParams
        });

        console.log('Resultado de búsqueda notif-process:', response?.data);
        return response;
    } catch (error) {
        console.log(error)
        throw error

    }
}

export const getProductLinkedLogs = async (params) => {
    try {
        const url = `${apiRoutes.debug.getProductLinkedLogs}`;
        return await api.get(url, { params });
    } catch (error) {
        console.log(error);
        throw new Error(error);
    }
};
